import { createSlice, createAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

const STATE_KEY = 'commandsEntity';

const fetchCommands = createAction(`[${STATE_KEY}]/fetchCommands`);
const fetchCommandsPending = createAction(`[${STATE_KEY}]/fetchCommandsPending`);
const fetchCommandsSuccess = createAction(`[${STATE_KEY}]/fetchCommandsSuccess`);
const fetchCommandsFailure = createAction(`[${STATE_KEY}]/fetchCommandsFailure`);

const INITIAL_STATE = {
	data: [],
	metadata: null,
	loading: false,
	error: null,
};

const commandsEntitySlice = createSlice({
	name: STATE_KEY,
	initialState: INITIAL_STATE,
	reducers: {},
	extraReducers: {
		[fetchCommandsPending]: (state) => {
			state.loading = true;
			state.error = null;
			state.data = [];
		},
		[fetchCommandsSuccess]: (state, action) => {
			state.loading = false;
			state.data = action.payload?.data || [];
			state.metadata = action.payload?.metadata || null;
		},
		[fetchCommandsFailure]: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const getCommandsEntityState = (state) => state[STATE_KEY] || INITIAL_STATE;

const selectCommandsData = createSelector(
	getCommandsEntityState,
	(s) => s.data
);

const selectCommandsPending = createSelector(
	getCommandsEntityState,
	(s) => s.loading
);

const selectCommandsTotalResults = createSelector(
	getCommandsEntityState,
	(s) => s.metadata?.page?.totalResults ?? 0
);

export const commandsEntityActions = {
	fetchCommands,
	fetchCommandsPending,
	fetchCommandsSuccess,
	fetchCommandsFailure,
};

export const commandsEntitySelectors = {
	selectCommandsData,
	selectCommandsPending,
	selectCommandsTotalResults,
};

export default commandsEntitySlice.reducer;
